import UIObject from '../common/dynamic-form/UIObject'
import { InputField, INPUT_TYPE } from '../common/dynamic-form/InputField'
import React from 'react';
import { Form, Select } from 'antd';
import { Timestamp } from 'firebase/firestore';
import dayjs from 'dayjs';
import { validatePhoneNumber } from '../common/Converter';
import customParseFormat from 'dayjs/plugin/customParseFormat'
import { dateFormatList } from '../common/dynamic-form/items/BaseInputItem';

dayjs.extend(customParseFormat);

export interface ISchool {
    id: string,
    name: string,
    phone?:string,
    note?:string,
    htName?:string,
    address?:string,
}

const prefixSelector = (
    <Form.Item noStyle>
        <Select style={{ width: 70 }} defaultValue='+84'>
            <Select.Option value="+84">+84</Select.Option>
        </Select>
    </Form.Item>
);


export default class SchoolObject extends UIObject {

    constructor(data: ISchool) {
        super(data);

        this.updateFieldProperties(new InputField({
            key: "id",
            label: "Mã trường",
            required: true,
            value: data.id,
            extra: {
                props: { placeholder: "Nhập mã trường học này..." },
                require_message: "Mã trường học là bắt buộc",
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                        required: true,
                        message: "Không được để trống mã trường học"
                    }
                ]
            }
        }), 0)

        this.updateFieldProperties(new InputField({
            key: "name",
            label: "Tên trường học ",
            required: true,
            value: data.name,
            extra: {
                props: { placeholder: "Nhập tên của trường học này..." },
                require_message: "Tên trường học là bắt buộc",
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                        required: true,
                        message: "Không được để trống tên trường học"
                    }
                ]
            }
        }), 1)

        this.updateFieldProperties(new InputField({
            key: "htName",
            label: "Tên Hiệu Trưởng ",
            value: data.htName,
            extra: {
                props: { placeholder: "Nhập tên hiệu trường của trường này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 2)
        this.updateFieldProperties(new InputField({
            key: "phone",
            label: "Số điện thoại ",
            value: data.phone,
            required: false,
            extra: {
                props: { placeholder: "Nhập Số điện thoại của trường học...", addonBefore: prefixSelector },
                // require_message: "Số điện thoại là bắt buộc",
                rules: [
                    {
                        type: "string",
                        // required: true,
                        whitespace: true,
                        // message: "Không được để trống số điện thoại"
                    }
                    ,{
                        max: 12,
                        min: 9
                    },
                    {
                        validator: (_: any, value: any) => validatePhoneNumber(value) ? Promise.resolve() : Promise.reject(new Error('Không đúng định dạng số điện thoại. Hãy kiểm tra lại!'))
                    }
                ]
            }
        }), 3)
        this.updateFieldProperties(new InputField({
            key: "address",
            label: "Địa chỉ ",
            value: data.address,
            extra: {
                props: { placeholder: "Nhập địa chỉ của trường này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 4)
        this.updateFieldProperties(new InputField({
            key: "note",
            label: "Ghi chú",
            value: data.note,
            extra: {
                props: { placeholder: "Nhập ghi chú thêm cho trường học này..." },
                rules: [
                    {
                        type: "string",
                        whitespace: true,
                    }
                ]
            }
        }), 5)


        this.mapData();
    }
}
